import React from 'react';
import { StatusMessage, StepInstructions, EGiftRecipe } from "../index";
import GiftPic from '../../assets/img/gift-card.jpg';
import { GiftContainer, GiftWrapper, GiftHeading, GiftImage } from "./styles";

const GiftConfirmationLayout = (props) => (
  <GiftContainer>
    <GiftWrapper>
      <GiftHeading>Confirmation</GiftHeading>
      <StatusMessage status={0} message='Thanks for purchasing a DayAxe eGift Card! Your gift is scheduled for delivery' />
      <StepInstructions steps={['Ask your friend to pick a pass', 'Use gift code in promo box at checkout', 'Enjoy your day!']} heading='How to redeem the gift card' />
      <GiftImage>
        <img src={GiftPic} alt="Redeem the gift card" />
      </GiftImage>
      <EGiftRecipe {...props} />
    </GiftWrapper>
  </GiftContainer>
);

export default GiftConfirmationLayout;
